import { Component, ViewEncapsulation, OnInit, HostListener, inject } from '@angular/core';
import { LoginService } from 'app/main/auth/login/login.service';
import { tap } from 'rxjs/operators';
import { Usuario } from '@cdk/models';
import { ChatBotService } from '@cdk/services/chat-bot.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'chat-bot',
    templateUrl: './chat-bot.component.html',
    styleUrls: ['./chat-bot.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatTooltip],
})
export class ChatBotComponent implements OnInit {

    private _chatBotService = inject(ChatBotService);
    
    readonly isDrawerOpen = this._chatBotService.chatBotDrawerState;

    isEnabled: boolean = false;

    constructor(private readonly _loginService: LoginService) { }

    ngOnInit(): void {
        this._loginService.getUserProfileChanges()
            .pipe(
                tap((usuario: Usuario) => {
                    const lotacoes = usuario?.colaborador?.lotacoes ?? [];
                    this.isEnabled = lotacoes.length > 0;
                })
            )
            .subscribe();
    }

    public toggleDrawer(event: MouseEvent): void {
        event.stopPropagation();
        this._chatBotService.toggleDrawer();
    }

    @HostListener('document:click', ['$event'])
    public onDocumentClick(): void {
        const target = event.target as HTMLElement;

        if (target.closest('#toolBarChatBotIcon')) {
            return;
        }

        if (this.isDrawerOpen) {
            this._chatBotService.closeDrawer();
        }
    }
}
